module.exports = __webpack_public_path__ + "img/gota.90eb72db.svg";